import React from 'react';
import { cloneDeep } from 'lodash';
import history from '../../../../history';
import { PanelGroup, Panel } from '../../compat/PanelCompat';
import CordellConnectUsers from './cordellConnectUsers';
import CordellConnectPackageZones from './cordellConnectPackageZones';
import UsersDefault from '../../../../image/Icons/Users-default.svg';
import UsersActive from '../../../../image/Icons/Users-active.svg';
import ZonesDefault from '../../../../image/Icons/Zones-default.svg';
import ZonesActive from '../../../../image/Icons/Zones-active.svg';

export default class CordellConnectProductPackageConfiguration extends React.Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.onUserClickAction = this.onUserClickAction.bind(this);

    this.onSelectingCordellGeography = this.props.onSelectingCordellGeography.bind(this);
    this.onGeographyClickAction = this.onGeographyClickAction.bind(this);

    this.onZonesSelect = this.onZonesSelect.bind(this);

    this.onSearchInputChange = this.props.onSearchInputChange.bind(this);
    this.onDeselectCouncil = this.props.onDeselectCouncil.bind(this);
    this.onCouncilSelect = this.props.onCouncilSelect.bind(this);
    this.getSuburbList = this.props.getSuburbList.bind(this);

    this.state = {
      mobile: false,
      activeKey: '2',
      geography: {
        states: null,
        state_type: null
      },
      number_of_users: 2
    };
  }

  /* istanbul ignore next */
  componentDidMount() {
    if (/Android|webOS|iPhone|iPod|ipad|BlackBerry/i.test(navigator.userAgent)) {
      this.setState({
        mobile: true
      });
    }
    this.setState({
      geography: this.props.productPackageDefaultConfig.configuration.geography
    });

    if (this.props.packageKey === 'trial') {
      this.props.onCordellTrialUser();
    }
  }

  /* istanbul ignore next */
  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  /* istanbul ignore next */
  onUserClickAction() {
    this.setState({ activeKey: '2' });
  }

  /* istanbul ignore next */
  onGeographyClickAction() {
    this.setState({ activeKey: '3' });
  }

  /* istanbul ignore next */
  onZonesSelect(state, type) {
    let geography = cloneDeep(this.props.productPackageDefaultConfig.configuration.geography);
    if (geography.states === null) geography.states = [];

    let index = geography.states.indexOf(state);
    if (index > -1) {
      geography.states.splice(index, 1);
    } else {
      geography.states.push(state);
    }

    geography.state_type = type;
    this.setState({
      geography: geography
    });
    this.props.onSelectingCordellGeography(geography);
  }

  /* istanbul ignore next */
  onClickOfCouncil() {
    window.scrollTo(0, 0);
  }

  render(props) {
    return (
      <div>
        <div className='row no-margin'>
          <div className='col-sm-12'>
            <div className='row'>
              <div className='back-btn' onClick={history.goBack}>
                {' '}
                &lt; Back{' '}
              </div>
              <hr />
            </div>
            <div className='row'>
              <div className='section-no-pad-title text-center'>Customise Your Subscription</div>
            </div>
          </div>
        </div>
        <div className='row white-bg padding-20'>
          <div className='col-sm-12 no-padding'>
            <PanelGroup
              accordion
              id='product-config-accordion'
              activeKey={this.state.activeKey}
              onSelect={this.handleSelect}
            >
              <Panel eventKey='1'>
                <Panel.Heading className='white-bg'>
                  <Panel.Title toggle>
                    <div type='button' className='row panel-title panel-button no-margin'>
                      <div className='col-xs-7 text-left text-success no-padding'>
                        {this.state.number_of_users == '' && (
                          <span>
                            <img src={UsersDefault} alt='' className='margin-right-5' />
                            Users
                          </span>
                        )}
                        {this.state.number_of_users != '' && (
                          <span>
                            <img src={UsersActive} alt='' className='margin-right-5' />
                            <span className='text-success'>Users</span>
                          </span>
                        )}
                      </div>
                      <div className='col-xs-5 text-right text-success no-padding'>
                        {this.state.number_of_users != '' && (
                          <span style={{"lineHeight": "30px"}} className='margin-right-5'>
                            2 Users
                          </span>
                        )}
                        {this.state.activeKey !== '1' && (
                          <span
                            className='panel-dropdown-icon carat-down text-success'
                            aria-hidden='true'
                          ></span>
                        )}
                        {this.state.activeKey === '1' && (
                          <span className='panel-dropdown-icon carat-up text-success' aria-hidden='true'></span>
                        )}
                      </div>
                    </div>
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <CordellConnectUsers
                    users={this.props.productPackageConfig.packages[this.props.packageKey].users}
                    selectedUser={
                      this.props.productPackageDefaultConfig.configuration.number_of_users
                    }
                    onSelectingCordellUser={this.props.onSelectingCordellUser}
                    onUserClickAction={this.onUserClickAction}
                  />
                </Panel.Body>
              </Panel>
              <Panel
                eventKey='2'
                onClick={() => {
                  this.onClickOfCouncil();
                }}
              >
                <Panel.Heading className='white-bg'>
                  <Panel.Title toggle>
                    <div type='button' className='row panel-title panel-button no-margin'>
                      <div className='col-xs-5 text-left no-padding'>
                        {this.props.packageKey !== 'residential_essentials' &&
                          (this.state.geography.states === null ||
                            this.state.geography.states.length === 0) &&
                          this.props.packageKey !== 'trial' && (
                            <span>
                              <img src={ZonesDefault} alt='' className='margin-right-5' />
                              <span className={this.state.activeKey !== '2' ? 'tan-text' : ''}>Zones</span>
                            </span>
                          )}
                        {this.props.packageKey !== 'residential_essentials' &&
                          ((this.state.geography.states !== null &&
                            this.state.geography.states.length > 0) ||
                            this.props.packageKey === 'trial') && (
                            <span>
                              <img src={ZonesActive} alt='' className='margin-right-5' />
                              <span className='text-success'>Zones</span>
                            </span>
                          )}
                        {this.props.packageKey === 'residential_essentials' && (
                          <span>
                            <img src={ZonesDefault} alt='' className='margin-right-5' />
                            <span>Councils</span>
                          </span>
                        )}
                      </div>
                      <div className='col-xs-7 text-right no-padding '>
                        {this.props.packageKey !== 'residential_essentials' &&
                          this.state.geography.states !== null &&
                          this.state.geography.states.length > 0 &&
                          this.props.packageKey !== 'trial' && (
                            <span className='margin-right-5 text-success'>
                              {this.props.productPackageDefaultConfig.configuration.geography.states.map(
                                function (state, subIndex, arr) {
                                  return (
                                    <span className='text-uppercase' key={subIndex}>
                                      {state}{arr.length - 1 == subIndex ? '' : ', '}
                                    </span>
                                  );
                                }
                              )}
                            </span>
                          )}
                        {this.state.activeKey !== '2' &&
                          (this.state.geography.states === null ||
                            this.state.geography.states.length === 0) &&
                          this.props.packageKey !== 'trial' && (
                            <span className='panel-dropdown-icon carat-down' aria-hidden='true'></span>
                          )}
                        {this.state.activeKey === '2' &&
                          (this.state.geography.states === null ||
                            this.state.geography.states.length === 0) &&
                          this.props.packageKey !== 'trial' && (
                            <span style={{ marginTop: '-2px' }} className='panel-dropdown-icon carat-up' aria-hidden='true'></span>
                          )}
                        {this.state.activeKey !== '2' &&
                          ((this.state.geography.states !== null &&
                            this.state.geography.states.length > 0) ||
                            this.props.packageKey === 'trial') && (
                            <span style={{ marginTop: '-2px' }}
                              className='panel-dropdown-icon carat-down text-success'
                              aria-hidden='true'
                            ></span>
                          )}
                        {this.state.activeKey === '2' &&
                          ((this.state.geography.states !== null &&
                            this.state.geography.states.length > 0) ||
                            this.props.packageKey === 'trial') && (
                            <span style={{ marginTop: '-2px' }}
                              className='panel-dropdown-icon carat-up text-success'
                              aria-hidden='true'
                            ></span>
                          )}
                      </div>
                    </div>
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                  <CordellConnectPackageZones
                    geography={
                      this.props.productPackageConfig.packages[this.props.packageKey].geography
                    }
                    selectedGeography={
                      this.props.productPackageDefaultConfig.configuration.geography
                    }
                    onSelectingCordellGeography={this.onSelectingCordellGeography}
                    onGeographyClickAction={this.onGeographyClickAction}
                    packageKey={this.props.packageKey}
                    onZonesSelect={this.onZonesSelect}
                  />
                </Panel.Body>
              </Panel>
            </PanelGroup>
          </div>
        </div>
      </div>
    );
  }
}
